import { TextField } from "@mui/material"

export default function Siret({label, value, onChange, required, disabled, error}){

    const handleChange = e => {
        let v = e.target.value.replace(/\D/g,'');
        return onChange(v);
    }

    const helperText = error ? "Ce numéro SIRET n'est pas valide" :
        "Identifiant de l'entreprise à 14 chiffres";

    return <TextField
        label={label || 'Numéro SIRET'}
        value={value || ''}
        onChange={handleChange}
        inputProps={{
            pattern: "[0-9]{14}", 
            minLength: 14, 
            maxLength: 14
        }}
        size='small'
        helperText={helperText}
        required={required ? true : false}
        disabled={disabled ? true : false}
        error={error}
    />
}